import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, map, switchMap } from 'rxjs';
import { CartBillService } from 'src/app/shared/services';

export interface FacilityCodeInfoType {
    facilityCode: string;
    awb: string;
}

@Injectable({
    providedIn: 'root',
})
export class ChoiceInformationService {
    private _facilityCodeInfoType: BehaviorSubject<FacilityCodeInfoType> = new BehaviorSubject<FacilityCodeInfoType>({
        facilityCode: '',
        awb: '',
    });

    constructor(private cartBillService: CartBillService) {}

    setFacilityCode(facilityCode: string, awb: string): void {
        this._facilityCodeInfoType.next({
            facilityCode,
            awb,
        });
    }

    getFacilityCode$(): Observable<FacilityCodeInfoType> {
        return this._facilityCodeInfoType.asObservable();
    }

    getFacilityCode(): string {
        return this._facilityCodeInfoType.value.facilityCode;
    }

    facilityCodeMatchWithCart(): Observable<boolean> {
        return this.cartBillService
            .getAWBInCart()
            .pipe(switchMap((awb) => this.getFacilityCode$().pipe(map((facilityCode) => awb === facilityCode.awb))));
    }
}
